import { render, staticRenderFns } from "./fileManage.vue?vue&type=template&id=10c27ec6&scoped=true"
import script from "./fileManage.vue?vue&type=script&lang=js"
export * from "./fileManage.vue?vue&type=script&lang=js"
import style0 from "./fileManage.vue?vue&type=style&index=0&id=10c27ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c27ec6",
  null
  
)

export default component.exports